import styled from 'styled-components';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
export var AuthorNameLink = styled.a.withConfig({
  displayName: "AuthorNameLink",
  componentId: "sc-1rhkw7s-0"
})(["", ";transition:color 0.1s ease;&:hover{color:", ";}"], fontSmoothing, function (_ref) {
  var theme = _ref.theme,
    withLink = _ref.withLink;
  return withLink ? theme.linkColor : theme.colors.font;
});